(() => {
  'use strict';
  const stringsNode = document.getElementById('rcm-strings');
  if (!stringsNode) return;
  const strings = JSON.parse(stringsNode.textContent);
  const t = (key) => strings[key] || key;
  const q = (root, selector) => root.querySelector(selector);
  const qa = (root, selector) => Array.from(root.querySelectorAll(selector));
  const textElement = (tag, text, className) => {
    const element = document.createElement(tag);
    element.textContent = text;
    if (className) element.className = className;
    return element;
  };
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency: strings.currency || 'USD'
  }).format(cents / 100);
  const modelGroups = [
    { id: 'airpods-pro-3', handle: 'apple-airpods-pro-3rd-gen-replacements-parts', name: 'AirPods Pro (3rd generation)', parts: { left: ['A3064'], right: ['A3063'], family: ['A3065'], case: ['A3122'] } },
    { id: 'airpods-pro-2-usbc', handle: 'airpods-pro-2nd-generation-usb-c-replacement-parts', name: 'AirPods Pro (2nd generation) USB-C', parts: { left: ['A3048'], right: ['A3047'], family: ['A3049'], case: ['A2968'] } },
    { id: 'airpods-pro-2-lightning', handle: 'airpods-pro-2nd-generation-replacement-parts', name: 'AirPods Pro (2nd generation) Lightning', parts: { left: ['A2699'], right: ['A2698'], family: ['A2931'], case: ['A2700'] } },
    { id: 'airpods-pro-1', handle: 'airpod-pro-replacement-parts', name: 'AirPods Pro (1st generation)', parts: { left: ['A2084'], right: ['A2083'], case: ['A2190'] } },
    { id: 'airpods-5-usbc', handle: 'airpods-5th-generation-replacement-parts', name: 'AirPods 5 with USB-C Charging Case', parts: { family: ['A3531', 'A3532', 'A3533'], case: ['A3530'] } },
    { id: 'airpods-5-wireless', handle: 'airpods-5th-generation-replacement-parts', name: 'AirPods 5 with Wireless Charging Case', parts: { family: ['A3439', 'A3440', 'A3441'], case: ['A3529'] } },
    { id: 'airpods-4-anc', handle: 'airpods-4th-generation-replacement-parts', name: 'AirPods (4th generation) with ANC', parts: { left: ['A3056'], right: ['A3055'], family: ['A3057'], case: ['A3059'] } },
    { id: 'airpods-4-standard', handle: 'airpods-4th-generation-replacement-parts', name: 'AirPods (4th generation) without ANC', parts: { left: ['A3053'], right: ['A3050'], family: ['A3054'], case: ['A3058'] } },
    { id: 'airpods-3', handle: 'airpod-3rd-gen-replacement-parts', name: 'AirPods (3rd generation)', parts: { left: ['A2564'], right: ['A2565'], case: ['A2566', 'A2897'] } },
    { id: 'airpods-2', handle: '2nd-gen-replacement-parts', name: 'AirPods (2nd generation)', parts: { left: ['A2031'], right: ['A2032'] } },
    { id: 'airpods-1', handle: '', name: 'AirPods (1st generation)', parts: { family: ['A1722', 'A1523'] } },
    { id: 'beats-fit-pro', handle: 'beats-fit-pro-replacement-parts', name: 'Beats Fit Pro', parts: { left: ['A2576'], right: ['A2577'], case: ['A2578'] } },
    { id: 'beats-studio-buds-plus', handle: 'beats-studio-buds-plus-replacement-parts', name: 'Beats Studio Buds+', parts: { left: ['A2872'], right: ['A2871'], case: ['A2870'] } },
    { id: 'beats-studio-buds', handle: 'beats-studio-buds-replacement-parts', name: 'Beats Studio Buds', parts: { left: ['A2512'], right: ['A2513'], case: ['A2514'] } },
    { id: 'powerbeats-pro', handle: 'powerbeats-pro-replacement-parts', name: 'Powerbeats Pro', parts: { left: ['A2047'], right: ['A2048'], case: ['A2078'] } },
    { id: 'galaxy-buds4-pro', handle: 'samsung-galaxy-buds4-pro-replacement-parts', name: 'Samsung Galaxy Buds4 Pro', parts: { family: ['SM-R640'] } },
    { id: 'galaxy-buds3-pro', handle: 'galaxy-buds-3-pro', name: 'Samsung Galaxy Buds3 Pro', parts: { family: ['SM-R630'] } },
    { id: 'galaxy-buds3', handle: 'galaxy-buds-3', name: 'Samsung Galaxy Buds3', parts: { family: ['SM-R530'] } },
    { id: 'galaxy-buds2-pro', handle: 'galaxy-buds-2-pro', name: 'Samsung Galaxy Buds2 Pro', parts: { family: ['SM-R510'] } },
    { id: 'galaxy-buds-pro', handle: 'galaxy-buds-pro', name: 'Samsung Galaxy Buds Pro', parts: { family: ['SM-R190'] } },
    { id: 'galaxy-buds2', handle: 'galaxy-buds2', name: 'Samsung Galaxy Buds2', parts: { family: ['SM-R177'] } },
    { id: 'galaxy-buds-plus', handle: 'galaxy-buds-plus', name: 'Samsung Galaxy Buds+', parts: { family: ['SM-R175'] } },
    { id: 'galaxy-buds-live', handle: 'samsung-galaxy-buds-live', name: 'Samsung Galaxy Buds Live', parts: { family: ['SM-R180'] } },
    { id: 'sony-linkbuds-s', handle: 'sony-wf-ls900n-linkbuds-s-replacement-parts', name: 'Sony LinkBuds S', parts: { family: ['WF-LS900N'] } }
  ];
  modelGroups.push(...[{"id": "powerbeats-fit", "handle": "powerbeats-fit", "name": "Powerbeats Fit", "parts": {"family": ["A3476", "A3477", "A3479"]}, "lookupOnly": true}, {"id": "powerbeats-pro-2", "handle": "beats-powerbeats-pro-2-replacement-parts", "name": "Powerbeats Pro 2", "parts": {"family": ["A3157", "A3158", "A3160"]}, "lookupOnly": true}, {"id": "beats-solo-buds", "handle": "beats-solo-buds-replacement-parts", "name": "Beats Solo Buds", "parts": {"family": ["A3150", "A3151", "A3152"]}, "lookupOnly": true}, {"id": "galaxy-buds4", "handle": "samsung-galaxy-buds4-replacement-parts", "name": "Samsung Galaxy Buds4", "parts": {"family": ["SM-R540", "SM-540"]}, "lookupOnly": true}, {"id": "galaxy-buds3-fe", "handle": "samsung-galaxy-buds3-fe-replacement-parts-for-sale", "name": "Samsung Galaxy Buds3 FE", "parts": {"family": ["SM-R420"]}, "lookupOnly": true}, {"id": "galaxy-buds-fe", "handle": "galaxy-buds-fe", "name": "Samsung Galaxy Buds FE", "parts": {"family": ["SM-R400"]}, "lookupOnly": true}, {"id": "pixel-buds-pro-2", "handle": "pixel-buds-pro-2", "name": "Google Pixel Buds Pro 2", "parts": {"family": ["GD3B4", "GW8XE", "G0DNE"]}, "lookupOnly": true}, {"id": "pixel-buds-pro", "handle": "pixel-buds-pro", "name": "Google Pixel Buds Pro", "parts": {"family": ["GA34L", "GQGM1", "GPX4H"]}, "lookupOnly": true}, {"id": "pixel-buds-2a", "handle": "pixel-buds-2a-replacement-parts", "name": "Google Pixel Buds 2a", "parts": {"family": ["G3UGY", "G76LT", "GNN2Z"]}, "lookupOnly": true}, {"id": "pixel-buds-a-series", "handle": "pixel-buds-a-series", "name": "Google Pixel Buds A-Series", "parts": {"family": ["G7YPJ", "GPQY2", "G7T9J"]}, "lookupOnly": true}, {"id": "pixel-buds-2", "handle": "google-pixel-buds-2nd-generation-replacement-parts", "name": "Google Pixel Buds (2nd generation)", "parts": {"family": ["G1007", "G1008", "G1013", "GA01470-US"]}, "lookupOnly": true}, {"id": "sony-wf-1000xm6", "handle": "sony-xm6-replacement-parts-1", "name": "Sony WF-1000XM6", "parts": {"family": ["WF-1000XM6"]}, "lookupOnly": true}, {"id": "sony-wf-1000xm5", "handle": "sony-xm5-replacement-parts", "name": "Sony WF-1000XM5", "parts": {"family": ["WF-1000XM5"]}, "lookupOnly": true}, {"id": "sony-wf-1000xm4", "handle": "sony-xm4-replacement-parts", "name": "Sony WF-1000XM4", "parts": {"family": ["WF-1000XM4"]}, "lookupOnly": true}, {"id": "sony-wf-1000xm3", "handle": "sony-wf-1000xm3-replacement-parts", "name": "Sony WF-1000XM3", "parts": {"family": ["WF-1000XM3"]}, "lookupOnly": true}, {"id": "sony-wf-c500", "handle": "sony-wf-c500-replacement-parts", "name": "Sony WF-C500", "parts": {"family": ["WF-C500"]}, "lookupOnly": true}, {"id": "sony-wf-c700n", "handle": "sony-wf-c700-replacement-parts", "name": "Sony WF-C700N", "parts": {"family": ["WF-C700N", "WF-C700"]}, "lookupOnly": true}, {"id": "sony-wf-xb700", "handle": "sony-wf-xb700-replacement-parts", "name": "Sony WF-XB700", "parts": {"family": ["WF-XB700"]}, "lookupOnly": true}, {"id": "bose-qc-ultra", "handle": "bose-quietcomfort-ultra-replacement-parts", "name": "Bose QuietComfort Ultra Earbuds (1st generation)", "parts": {"family": ["441408", "441408L", "441408R"]}, "lookupOnly": true, "excludeTitle": "2nd|second|gen(?:eration)?[ -]*2"}, {"id": "bose-qc-ii", "handle": "bose-quietcomfort-earbuds-ii-replacement-parts", "name": "Bose QuietComfort Earbuds II", "parts": {"family": ["435911"]}, "lookupOnly": true}, {"id": "bose-soundsport-free", "handle": "bose-soundsport-free-wireless-replacement-parts", "name": "Bose SoundSport Free", "parts": {"family": ["423729", "BL1L", "BL1R"]}, "lookupOnly": true}]);
  modelGroups.push({ id: 'bose-qc-ultra-2', handle: 'bose-quietcomfort-ultra-replacement-parts', name: 'Bose QuietComfort Ultra Earbuds (2nd generation)', parts: {}, lookupOnly: true, includeTitle: '2nd|second|gen(?:eration)?[ -]*2' });
  const normalizeCode = (value) => String(value || '').toUpperCase().replace(/[\s\u2010-\u2015-]/g, '');
  const interpolate = (key, values = {}) => Object.entries(values).reduce((copy, [name, value]) => copy.replaceAll('[' + name + ']', value), t(key));
  const findModel = (value) => {
    const normalized = normalizeCode(value);
    const knownCodes = [...new Set(['A1602', 'A1938', ...modelGroups.flatMap((group) => Object.values(group.parts).flat())].map(normalizeCode))];
    const exact = knownCodes.includes(normalized);
    const aliases = exact ? [] : knownCodes.filter((known) => {
      if (/^A\d{4}$/.test(known)) return normalized === known.slice(1);
      if (/^SMR?\d{3}$/.test(known)) return normalized === known.slice(2) || normalized === known.replace(/^SMR?/, '');
      if (known.startsWith('WF')) return normalized === known.slice(2);
      return false;
    });
    const aliasTargets = new Set(aliases.flatMap((alias) => modelGroups.flatMap((group) => Object.entries(group.parts).filter(([, codes]) => codes.some((item) => normalizeCode(item) === alias)).map(([part]) => group.id + ':' + part))));
    const code = aliases.length === 1 || (aliases.length > 1 && aliasTargets.size === 1) ? aliases[0] : normalized;
    if (['A1602', 'A1938'].includes(code)) return { code, part: 'case', ambiguous: true };
    for (const group of modelGroups) {
      for (const [part, codes] of Object.entries(group.parts)) {
        if (codes.some((item) => normalizeCode(item) === code)) return { code, group, part };
      }
    }
    return null;
  };
  const productPart = (title) => {
    if (/\bleft\b/i.test(title)) return 'left';
    if (/\bright\b/i.test(title)) return 'right';
    if (/charging\s+case|case\s+replacement/i.test(title)) return 'case';
    return null;
  };
  const groupsInText = (value) => {
    const codes = String(value || '').toUpperCase().match(/\bA\d{4}\b|\bSM-?R?\d{3}\b|\bWF-?[A-Z0-9]+\b|\bG[A-Z0-9]{4}\b|\b\d{6}[LR]?\b|\bBL1[LR]\b/g) || [];
    return [...new Set(codes.map((code) => findModel(code)?.group).filter(Boolean))];
  };
  const variantGroup = (product, variant, collections = []) => {
    const variantText = [variant?.title, ...(variant?.options || []), variant?.option1, variant?.option2, variant?.option3].filter(Boolean).join(' ');
    const variantGroups = groupsInText(variantText);
    if (variantGroups.length === 1) return variantGroups[0];
    if (variantGroups.length > 1) return null;
    const productGroups = groupsInText(product.title);
    const candidates = modelGroups.filter((group) => group.handle && collections.includes(group.handle) && (!group.excludeTitle || !new RegExp(group.excludeTitle, 'i').test(product.title)) && (!group.includeTitle || new RegExp(group.includeTitle, 'i').test(product.title)));
    const text = variantText.toLowerCase();
    if ([...candidates, ...productGroups].some((group) => group.id.startsWith('airpods-4-'))) {
      if (/non[\s-]*anc|without\s+(anc|active noise cancellation)/i.test(text)) return modelGroups.find((group) => group.id === 'airpods-4-standard');
      if (/\banc\b|active noise cancellation/i.test(text)) return modelGroups.find((group) => group.id === 'airpods-4-anc');
    }
    if ([...candidates, ...productGroups].some((group) => group.id.startsWith('airpods-5-'))) {
      if (/wireless charging case|wireless case/i.test(text)) return modelGroups.find((group) => group.id === 'airpods-5-wireless');
      if (/usb[\s-]*c charging case|usb[\s-]*c case/i.test(text)) return modelGroups.find((group) => group.id === 'airpods-5-usbc');
    }
    if (productGroups.length === 1) return productGroups[0];
    if (candidates.length === 1) return candidates[0];
    return null;
  };
  const compatibilityResult = (found, target, targetPart) => {
    if (!found) return { state: 'unknown', key: 'product.unknown_match' };
    if (found.ambiguous) return { state: 'unknown', key: 'product.shared_case' };
    if (target && found.group.id !== target.id && !(targetPart === 'case' && ((target.id.startsWith('airpods-pro-2-') && found.group.id.startsWith('airpods-pro-2-')) || (['airpods-1', 'airpods-2'].includes(target.id) && ['airpods-1', 'airpods-2'].includes(found.group.id))))) return { state: 'no', key: 'product.exact_mismatch', model: found.group.name, selected: target.name };
    if (!target || !targetPart) return { state: 'unknown', key: 'product.unverified_selection', model: found.group.name };
    if (found.code === 'A2968' && found.part === 'case' && target.id === 'airpods-pro-2-usbc' && ['left', 'right'].includes(targetPart)) return { state: 'yes', message: '✓ Compatible case identified: Your A2968 charging case matches AirPods Pro 2 USB-C. We also recommend checking the model number on your remaining earbud to confirm it’s the same version.' };
    if (found.part === 'case' && found.group.id.startsWith('airpods-pro-2-')) return { state: 'unknown', key: 'product.pro2_case_only' };
    if (targetPart === 'case' && target.id.startsWith('airpods-pro-2-') && found.group.id.startsWith('airpods-pro-2-') && found.group.id !== target.id) return { state: 'unknown', key: 'product.pro2_case_check' };
    if (targetPart === 'case' && ['airpods-1', 'airpods-2'].includes(target.id) && ['airpods-1', 'airpods-2'].includes(found.group.id) && found.group.id !== target.id) return { state: 'unknown', key: 'product.shared_case_product' };
    if (found.group.lookupOnly || target.lookupOnly) return { state: 'unknown', message: 'Your model number identifies ' + found.group.name + '. Confirm the missing side and color before ordering.' };
    if (found.group.id !== target.id) return { state: 'no', key: 'product.exact_mismatch', model: found.group.name, selected: target.name };
    if (found.part === targetPart) return { state: 'unknown', key: found.part === 'case' ? 'product.case_to_case' : 'product.same_side', model: target.name, side: t('finder.' + targetPart) };
    if (found.part === 'case' && target.id.startsWith('airpods-5-') && targetPart !== 'case') return { state: 'yes', key: 'product.case_version_match', number: found.code, model: target.name };
    if (found.part === 'family') return { state: 'unknown', key: 'product.family_identified', model: target.name };
    return { state: 'yes', key: 'product.exact_match', model: target.name };
  };
  const handleFromURL = (url) => {
    try { return new URL(url, location.origin).pathname.split('/collections/')[1]?.split('/')[0] || ''; }
    catch { return ''; }
  };
  const safeStoreURL = (url) => {
    const parsed = new URL(url, location.origin);
    if (parsed.origin !== location.origin) throw new Error('Unexpected collection origin');
    return parsed;
  };
  function initFinder(root) {
    if (root.dataset.rcmReady) return;
    root.dataset.rcmReady = 'true';
    const catalog = JSON.parse(q(root, '[data-rcm-catalog]').textContent);
    catalog.brands.forEach((brandEntry) => {
      brandEntry.models = brandEntry.models.flatMap((entry) => {
        if (handleFromURL(entry.url) !== 'bose-quietcomfort-ultra-replacement-parts') return [entry];
        return ['bose-qc-ultra', 'bose-qc-ultra-2'].map((id) => {
          const group = modelGroups.find((item) => item.id === id);
          const url = safeStoreURL(entry.url);
          url.searchParams.set('rcm_model', id);
          return { ...entry, label: group.name, url: url.pathname + url.search, parts: { ...entry.parts } };
        });
      });
    });
    const brand = q(root, '[data-rcm-brand]');
    const model = q(root, '[data-rcm-model]');
    const part = q(root, '[data-rcm-part]');
    const status = q(root, '[data-rcm-status]');
    const results = q(root, '[data-rcm-results]');
    const cards = q(root, '[data-rcm-result-cards]');
    const button = q(root, '[data-rcm-find-button]');
    const codeInput = q(root, '[data-rcm-code]');
    const findForm = q(root, '[data-rcm-find-form]');
    const syncPartChoices = () => {
      const selectedModel = catalog.brands.find((item) => item.id === brand.value)?.models.find((item) => item.url === model.value);
      const selectedBrand = catalog.brands.find((item) => item.id === brand.value);
      const isBose = selectedBrand?.label.toLowerCase() === 'bose';
      const offeredParts = isBose && selectedModel ? ['left', 'right', 'case'].filter((name) => selectedModel.parts?.[name]) : null;
      if (offeredParts && offeredParts.length && !offeredParts.includes(part.value)) part.value = offeredParts.length === 1 ? offeredParts[0] : 'all';
      let note = q(root, '[data-rcm-parts-note]');
      if (!note) {
        note = textElement('p', '', 'rcm-muted');
        note.dataset.rcmPartsNote = '';
        q(root, '[data-rcm-part-field]').append(note);
      }
      note.hidden = !(offeredParts?.length === 1 && offeredParts[0] === 'case');
      note.textContent = note.hidden ? '' : 'Charging-case replacements only for this model. We do not offer individual replacement earbuds for this model.';
      qa(root, '[data-rcm-choose-part]').forEach((tile) => {
        const name = tile.dataset.rcmChoosePart;
        tile.hidden = Boolean(offeredParts && (name === 'all' ? offeredParts.length <= 1 : !offeredParts.includes(name)));
        const active = tile.dataset.rcmChoosePart === part.value;
        tile.classList.toggle('is-selected', active);
        tile.setAttribute('aria-pressed', String(active));
        const img = q(tile, '[data-rcm-part-image]');
        if (!img) return;
        const src = selectedModel?.parts?.[tile.dataset.rcmChoosePart];
        if (src) img.src = src;
        else img.removeAttribute('src');
        img.hidden = !src;
        q(tile, '[data-rcm-part-symbol]').hidden = Boolean(src);
      });
      q(root, '[data-rcm-part-step]').classList.toggle('is-active', Boolean(model.value));
    };
    let request;
    let sequence = 0;
    const invalidate = () => {
      sequence += 1;
      if (request) request.abort();
      button.disabled = false;
      button.textContent = t('finder.submit');
      results.hidden = true;
      status.textContent = '';
    };
    const populateModels = () => {
      invalidate();
      model.replaceChildren(new Option(t('finder.model_placeholder'), ''));
      const selectedBrand = catalog.brands.find((item) => item.id === brand.value);
      (selectedBrand?.models || []).forEach((item) => model.add(new Option(item.label, item.url)));
      model.disabled = !selectedBrand || !selectedBrand.models.length;
      qa(root, '[data-rcm-brand-choice]').forEach((tile) => {
        const active = tile.dataset.rcmBrandChoice === brand.value;
        tile.classList.toggle('is-selected', active);
        tile.setAttribute('aria-pressed', String(active));
      });
      if (selectedBrand && !selectedBrand.models.length) {
        model.add(new Option(selectedBrand.label, selectedBrand.url));
        model.disabled = false;
      }
      q(root, '[data-rcm-part-field]').hidden = true;
      q(root, '[data-rcm-model-step]').classList.remove('is-active');
      syncPartChoices();
    };
    const advanceToModel = () => {
      q(root, '[data-rcm-model-step]').classList.add('is-active');
      q(root, '.rcm-model-field').classList.add('is-next');
      model.focus({ preventScroll: true });
      model.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };
    brand.addEventListener('change', () => { codeInput.value = ''; populateModels(); advanceToModel(); });
    model.addEventListener('change', () => {
      q(root, '.rcm-model-field').classList.toggle('is-next', !model.value);
      codeInput.value = '';
      invalidate();
      q(root, '[data-rcm-part-field]').hidden = !model.value;
      q(root, '[data-rcm-model-step]').classList.toggle('is-active', Boolean(model.value));
      syncPartChoices();
    });
    qa(root, '[data-rcm-brand-choice]').forEach((tile) => tile.addEventListener('click', () => {
      brand.value = tile.dataset.rcmBrandChoice;
      codeInput.value = '';
      populateModels();
      advanceToModel();
    }));
    qa(root, '[data-rcm-choose-part]').forEach((tile) => tile.addEventListener('click', () => {
      invalidate();
      part.value = tile.dataset.rcmChoosePart;
      syncPartChoices();
    }));
    populateModels();
    part.addEventListener('change', () => { invalidate(); syncPartChoices(); });
    codeInput.addEventListener('input', invalidate);
    const search = async (requireNumber = false) => {
      const typed = codeInput.value.trim();
      const found = typed ? findModel(typed) : null;
      let selectedGroup = null;
      let modelNote = '';
      if (requireNumber && !typed) { invalidate(); status.textContent = t('product.enter_number'); codeInput.focus(); return; }
      if (typed) {
        if (found?.ambiguous) { invalidate(); status.textContent = t('product.shared_case'); return; }
        if (found?.part === 'case' && found.group.id.startsWith('airpods-pro-2-') && part.value !== 'case') {
          invalidate(); status.textContent = t('product.pro2_case_only'); return;
        }
        const group = found?.group;
        const typedBrand = group && catalog.brands.find((item) => item.models.some((entry) => handleFromURL(entry.url) === group.handle));
        const typedModel = typedBrand?.models.find((item) => handleFromURL(item.url) === group.handle);
        if (!typedModel) { invalidate(); status.textContent = group ? group.name + ' identified. Replacement options are not currently listed in this finder. Contact us for availability.' : t('finder.unknown_number'); return; }
        const keepPart = part.value;
        brand.value = typedBrand.id;
        populateModels();
        model.value = typedModel.url;
        part.value = keepPart;
        q(root, '[data-rcm-part-field]').hidden = false;
        q(root, '[data-rcm-model-step]').classList.add('is-active');
        syncPartChoices();
        selectedGroup = group;
        modelNote = interpolate('finder.exact_model_found', { number: typed.toUpperCase(), model: group.name });
      }
      if (!findForm.reportValidity()) return;
      invalidate();
      const currentSequence = sequence;
      const selectedPart = part.value;
      const controller = new AbortController();
      request = controller;
      button.disabled = true;
      button.textContent = t('finder.loading');
      status.textContent = t('finder.loading');
      const collectionURL = safeStoreURL(model.value);
      if (!selectedGroup) {
        const selectionId = collectionURL.searchParams.get('rcm_model');
        selectedGroup = modelGroups.find((group) => group.id === selectionId && group.handle === handleFromURL(collectionURL.href)) || null;
      }
      const endpoint = new URL(collectionURL);
      endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + '/products.json';
      endpoint.search = '?limit=250';
      const timeout = setTimeout(() => controller.abort(), 12000);
      try {
        const response = await fetch(endpoint, { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Collection unavailable');
        const data = await response.json();
        if (currentSequence !== sequence) return;
        const matching = (data.products || []).filter((product) => {
          const title = product.title.toLowerCase();
          if (selectedGroup?.excludeTitle && new RegExp(selectedGroup.excludeTitle, 'i').test(title)) return false;
          if (selectedGroup?.includeTitle && !new RegExp(selectedGroup.includeTitle, 'i').test(title)) return false;
          if (/protective|transparent|silicone|lanyard|cover|shell|ear tips|earbuds? tips|earpads|full set|complete set/.test(title)) return false;
          if (selectedPart === 'all') return /\bleft\b|\bright\b|charging case|case replacement/.test(title);
          if (selectedPart === 'left') return /\bleft\b/.test(title);
          if (selectedPart === 'right') return /\bright\b/.test(title);
          return /\bcase\b/.test(title) && /charging|replacement/.test(title) && !/\bwith\b.*\bcase\b/.test(title);
        }).map((product) => ({
          ...product,
          variants: selectedGroup ? product.variants.filter((variant) => variantGroup(product, variant, [selectedGroup.handle])?.id === selectedGroup.id) : product.variants
        })).filter((product) => product.variants.length);
        cards.replaceChildren();
        const allModelLink = q(root, '[data-rcm-all-model]');
        allModelLink.href = collectionURL.href;
        allModelLink.hidden = Boolean(selectedGroup?.includeTitle || selectedGroup?.excludeTitle);
        const heading = q(root, '[data-rcm-results-heading]');
        heading.textContent = (selectedGroup?.name || model.selectedOptions[0].textContent) + ' · ' + part.selectedOptions[0].textContent;
        if (!matching.length) {
          status.textContent = t('finder.no_results');
          cards.append(textElement('p', t('finder.no_results'), 'rcm-muted'));
        } else {
          matching.forEach((product) => {
            const available = product.variants.filter((variant) => variant.available);
            const selectedVariant = available[0] || product.variants[0];
            const neutralAirPods4 = !selectedGroup && handleFromURL(collectionURL.href) === 'airpods-4th-generation-replacement-parts' && ['left', 'right'].includes(selectedPart) && product.variants.some((variant) => variantGroup(product, variant, ['airpods-4th-generation-replacement-parts'])?.id === 'airpods-4-anc') && product.variants.some((variant) => variantGroup(product, variant, ['airpods-4th-generation-replacement-parts'])?.id === 'airpods-4-standard');
            const card = textElement('article', '', 'rcm-product-card');
            const link = new URL((root.dataset.root || '/') + 'products/' + product.handle, location.origin);
            if (selectedVariant && !neutralAirPods4) link.searchParams.set('variant', selectedVariant.id);
            const neutralImage = neutralAirPods4 ? catalog.brands.find((item) => item.id === brand.value)?.models.find((item) => item.url === model.value)?.parts?.[selectedPart] : null;
            const cardImage = neutralImage || selectedVariant?.featured_image?.src || product.images?.[0]?.src;
            if (cardImage) {
              const img = document.createElement('img');
              img.src = cardImage;
              img.alt = product.title;
              img.loading = 'lazy';
              img.width = 360;
              img.height = 240;
              card.append(img);
            }
            card.append(textElement('h3', product.title));
            if (selectedVariant) {
              const priceOptions = available.length ? available : product.variants;
              const minimumPrice = Math.min(...priceOptions.map((variant) => Number(variant.price)));
              card.append(textElement('p', (neutralAirPods4 ? 'From ' : '') + money((neutralAirPods4 ? minimumPrice : Number(selectedVariant.price)) * 100), 'rcm-product-price'));
              if (neutralAirPods4) card.append(textElement('p', 'ANC and non-ANC options. Check and choose your version on the product page.', 'rcm-product-option'));
              else if (selectedVariant.title && selectedVariant.title !== 'Default Title') card.append(textElement('p', interpolate('finder.shown_option', { option: selectedVariant.title }), 'rcm-product-option'));
            }
            const stock = textElement('p', available.length ? t('product.in_stock') : t('product.sold_out'), 'rcm-product-stock');
            stock.dataset.available = String(available.length > 0);
            const cta = textElement('a', t('finder.view_options') + ' →', 'rcm-button');
            cta.href = link.href;
            card.append(stock, cta);
            cards.append(card);
          });
          status.textContent = modelNote ? modelNote + ' ' + t('finder.results_ready') : t('finder.results_ready');
        }
        results.hidden = false;
        heading.focus({ preventScroll: true });
        results.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        document.dispatchEvent(new CustomEvent('recell:finder-results', { detail: { model: handleFromURL(model.value), part: selectedPart, count: matching.length } }));
      } catch (error) {
        if (currentSequence !== sequence) return;
        status.replaceChildren(textElement('span', t('finder.load_error') + ' '));
        const fallback = textElement('a', t('finder.all_parts') + ' →');
        fallback.href = collectionURL.href;
        status.append(fallback);
      } finally {
        clearTimeout(timeout);
        if (currentSequence === sequence) {
          button.disabled = false;
          button.textContent = t('finder.submit');
        }
      }
    };
    q(root, '[data-rcm-code-form]').addEventListener('submit', (event) => { event.preventDefault(); search(true); });
    findForm.addEventListener('submit', (event) => { event.preventDefault(); search(); });
  }
  function initCompatibility(root) {
    if (root.dataset.rcmReady) return;
    root.dataset.rcmReady = 'true';
    const collections = JSON.parse(q(root, '[data-rcm-collections]').textContent);
    const container = root.closest('[data-section-type="product-template"]');
    const form = container && q(container, '.product-single__form');
    const variantNode = container && q(container, '[id^="VariantsJson-"]');
    const variants = variantNode ? JSON.parse(variantNode.value || variantNode.textContent) : [];
    const input = q(root, '[data-rcm-check-input]');
    const result = q(root, '[data-rcm-check-result]');
    const actions = q(root, '[data-rcm-match-actions]');
    const shopLink = q(root, '[data-rcm-match-shop]');
    let matchRequest = null;
    let matchSequence = 0;
    const resetActions = () => {
      matchSequence += 1;
      if (matchRequest) matchRequest.abort();
      if (actions) actions.hidden = true;
      if (shopLink) { shopLink.hidden = true; shopLink.removeAttribute('href'); }
    };
    const offerReplacement = async (found, missingPart) => {
      if (!shopLink || !found?.group?.handle || !missingPart) return;
      const sequence = matchSequence;
      const collectionURL = new URL((strings.root || '/') + 'collections/' + found.group.handle, location.origin);
      shopLink.href = collectionURL.href;
      shopLink.textContent = t('product.browse_matching_model');
      shopLink.hidden = false;
      const controller = new AbortController();
      matchRequest = controller;
      const timeout = setTimeout(() => controller.abort(), 8000);
      try {
        const response = await fetch(collectionURL.pathname + '/products.json?limit=250', { credentials: 'same-origin', signal: controller.signal });
        if (!response.ok) return;
        const data = await response.json();
        if (sequence !== matchSequence) return;
        for (const candidate of data.products || []) {
          if (productPart(candidate.title) !== missingPart || /protective|cover|shell|full set|complete set|ear tips/i.test(candidate.title)) continue;
          const matchingVariant = candidate.variants.find((variant) => variant.available && variantGroup(candidate, variant, [found.group.handle])?.id === found.group.id);
          if (!matchingVariant) continue;
          const productURL = new URL((strings.root || '/') + 'products/' + candidate.handle, location.origin);
          productURL.searchParams.set('variant', matchingVariant.id);
          shopLink.href = productURL.href;
          shopLink.textContent = t('product.shop_correct_replacement');
          return;
        }
      } catch (error) {
        if (error.name !== 'AbortError' && sequence === matchSequence) shopLink.textContent = t('product.browse_matching_model');
      } finally { clearTimeout(timeout); }
    };
    let checked = false;
    const disclosure = q(root, 'details');
    if (disclosure) disclosure.open = matchMedia('(min-width: 769px)').matches;
    const selectedVariant = () => {
      const selections = form ? qa(form, '.variant-input-wrap').map((fieldset) => q(fieldset, 'input:checked, select')?.value) : [];
      if (selections.length) return variants.find((variant) => variant.options.every((value, index) => value === selections[index]));
      const master = form && q(form, '[name="id"]');
      return variants.find((variant) => String(variant.id) === master?.value);
    };
    const check = (announce = true) => {
      resetActions();
      const value = input.value.trim();
      checked = Boolean(value);
      result.dataset.match = 'unknown';
      if (!value) { result.textContent = t('product.enter_number'); return; }
      const variant = selectedVariant();
      const product = { title: root.dataset.productTitle };
      const target = variant ? variantGroup(product, variant, collections) : null;
      const found = findModel(value);
      const missingPart = productPart(product.title);
      const enteredCode = found?.code || normalizeCode(value);
      const selectedCodes = (product.title + ' ' + (variant?.title || '')).toUpperCase().split(/[^A-Z0-9-]+/);
      const exactSelectedCode = found && !found.ambiguous && target && missingPart && found.group.id === target.id && !(found.part === 'case' && missingPart !== 'case') && selectedCodes.some((code) => normalizeCode(code) === enteredCode);
      const answer = exactSelectedCode
        ? { state: 'yes', message: '✓ Model confirmed: ' + enteredCode + ' matches this ' + (missingPart === 'case' ? 'charging-case' : missingPart + '-ear') + ' replacement. Please confirm your color before ordering.' }
        : compatibilityResult(found, target, missingPart);
      result.dataset.match = answer.state;
      result.textContent = answer.message || interpolate(answer.key, answer);
      if (actions && answer.state !== 'yes') actions.hidden = false;
      if (answer.state === 'no') offerReplacement(found, missingPart);
      if (announce) document.dispatchEvent(new CustomEvent('recell:compatibility-check', { detail: { result: answer.state } }));
    };
    q(root, '[data-rcm-check]').addEventListener('click', () => check());
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') { event.preventDefault(); check(); }
    });
    input.addEventListener('input', () => { checked = false; result.textContent = ''; result.dataset.match = 'unknown'; resetActions(); });
    if (form) form.addEventListener('change', () => { if (checked) setTimeout(() => check(false), 0); });
    if (container && window.jQuery) window.jQuery(container).on('variantChange.recellCompatibility', () => { if (checked) setTimeout(() => check(false), 0); });
  }
  function initProduct(container) {
    if (container.dataset.rcmReady) return;
    const form = q(container, '.product-single__form');
    const json = q(container, '[id^="VariantsJson-"]');
    if (!form || !json) return;
    container.dataset.rcmReady = 'true';
    const variants = JSON.parse(json.value || json.textContent);
    const mainButton = q(form, '[name="add"]');
    const express = q(form, '.rcm-express');
    const installments = q(form, '.shop-pay-installments');
    if (express && installments) express.append(installments);
    const master = q(form, 'select[name="id"]');
    const liveStock = q(container, '[data-rcm-live-stock]');
    const sticky = q(container, '[data-rcm-sticky]');
    const stickyButton = sticky && q(sticky, 'button');
    const displayedPrice = q(container, '[id^="ProductPrice-"]');
    const heading = q(container, '[data-rcm-product-heading]');
    const mobileSlot = q(container, '[data-rcm-mobile-heading]');
    const desktopSlot = q(container, '[data-rcm-desktop-heading]');
    const mq = matchMedia('(max-width: 768px)');
    const placeHeading = () => { if (heading && mobileSlot && desktopSlot) (mq.matches ? mobileSlot : desktopSlot).append(heading); };
    placeHeading();
    mq.addEventListener('change', placeHeading);
    let selected = variants.find((variant) => String(variant.id) === master?.value);
    const identity = q(container, '[data-rcm-product-identity]');
    const identityCollections = q(container, '[data-rcm-collections]');
    const productCollections = identityCollections ? JSON.parse(identityCollections.textContent) : [];
    const identityFallback = identity?.textContent || '';
    const syncIdentity = (variant) => {
      if (!identity) return;
      const product = { title: identity.dataset.productTitle };
      const part = productPart(product.title);
      const group = part && variant ? variantGroup(product, variant, productCollections) : null;
      if (!group) { identity.textContent = identityFallback; identity.hidden = !identityFallback.trim(); return; }
      const variantCodes = String(variant.title || '').toUpperCase().match(/\bA\d{4}\b|\bSM-?R\d{3}\b|\bWF-?LS900N\b/g) || [];
      const titleCodes = product.title.toUpperCase().match(/\bA\d{4}\b|\bSM-?R\d{3}\b|\bWF-?LS900N\b/g) || [];
      const groupCodes = group.parts[part] || group.parts.family || [];
      const ownCodes = (variantCodes.length ? variantCodes : titleCodes).filter((code) => groupCodes.some((item) => normalizeCode(item) === normalizeCode(code)));
      identity.textContent = group.name + (ownCodes.length ? ' · ' + t('product.model_label') + ' ' + ownCodes.join(' / ') : '');
      identity.hidden = false;
    };
    const quantityInput = q(form, '[name="quantity"]');
    const quantity = () => Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1);
    const addOn = q(container, '[data-rcm-addon]');
    const addOnPrice = () => {
      if (!addOn || !q(addOn, '[data-addon-check]')?.checked) return 0;
      return Number(q(addOn, '[data-addon-select]')?.selectedOptions[0]?.dataset.price || 0);
    };
    const syncButtonPrice = () => qa(form, '[data-rcm-button-price]').forEach((node) => {
      node.textContent = selected?.available ? ' — ' + money((selected.price + addOnPrice()) * quantity()) : '';
    });
    const syncSticky = () => {
      if (!sticky || !mainButton) return;
      q(sticky, '[data-rcm-sticky-price]').textContent = selected ? money((selected.price + addOnPrice()) * quantity()) : '—';
      q(sticky, '[data-rcm-sticky-option]').textContent = (quantity() > 1 ? quantity() + ' × ' : '') + (selected?.public_title || selected?.title || '');
      stickyButton.disabled = mainButton.disabled || !selected?.available;
      stickyButton.textContent = selected?.available ? (q(mainButton, '[data-default-text]')?.dataset.defaultText || 'Add to cart') : t('product.sold_out');
    };
    const refreshCards = () => {
      const selections = [];
      qa(form, '.variant-input-wrap').forEach((fieldset) => {
        const index = Number(fieldset.dataset.index.replace('option', '')) - 1;
        selections[index] = q(fieldset, 'input:checked, select')?.value;
      });
      qa(form, '.rcm-conditions .variant-input').forEach((card) => {
        const input = q(card, 'input');
        const index = Number(card.dataset.index.replace('option', '')) - 1;
        const candidate = variants.find((variant) => variant.options.every((value, optionIndex) => value === (optionIndex === index ? input.value : selections[optionIndex])));
        q(card, '[data-rcm-option-price]').textContent = candidate ? money(candidate.price) : '—';
        q(card, '[data-rcm-option-stock]').textContent = candidate?.available ? '' : t('product.sold_out');
        q(card, 'label').classList.toggle('disabled', !candidate?.available);
        input.classList.toggle('disabled', !candidate?.available);
      });
    };
    const update = (variant) => {
      selected = variant;
      syncIdentity(variant);
      if (liveStock) {
        liveStock.textContent = variant?.available ? t('product.in_stock') : t('product.sold_out');
        liveStock.dataset.available = String(Boolean(variant?.available));
      }
      syncButtonPrice();
      refreshCards();
      qa(form, '.rcm-conditions').forEach((group) => {
        const value = q(group, 'input:checked')?.value;
        const heading = qa(container, '.product-single__description-full h4, .product-single__description h4').find((item) => item.textContent.trim().toLowerCase() === value?.toLowerCase());
        const description = heading?.nextElementSibling;
        const output = q(group, '[data-rcm-selected-description]');
        if (output) {
          const copy = description?.tagName === 'P' ? description.textContent.trim() : '';
          output.hidden = !copy;
          output.textContent = copy;
        }
      });
      syncSticky();
    };
    if (window.jQuery) window.jQuery(container).on('variantChange.recellMatch', (event) => {
      update(event.variant);
      setTimeout(syncSticky, 0);
    });
    form.addEventListener('change', () => setTimeout(() => {
      const selections = qa(form, '.variant-input-wrap').map((fieldset) => q(fieldset, 'input:checked, select')?.value);
      const variant = selections.length ? variants.find((item) => item.options.every((value, index) => value === selections[index])) : variants.find((item) => String(item.id) === master?.value);
      update(variant || null);
    }, 0));
    if (quantityInput) {
      const refreshQuantity = () => { syncButtonPrice(); syncSticky(); };
      quantityInput.addEventListener('input', refreshQuantity);
      quantityInput.addEventListener('change', refreshQuantity);
      if (window.jQuery) {
        window.jQuery(quantityInput).on('change.recellMatchQuantity', refreshQuantity);
        window.jQuery(document.body).on('qty.product.recellMatchQuantity', () => { if (container.isConnected) refreshQuantity(); });
      }
    }
    if (sticky && mainButton) {
      document.body.classList.add('rcm-has-sticky');
      sticky.hidden = false;
      stickyButton.addEventListener('click', () => { if (!mainButton.disabled) mainButton.click(); });
      new MutationObserver(syncSticky).observe(mainButton, { attributes: true, attributeFilter: ['disabled', 'class'], childList: true, subtree: true, characterData: true });
      if (displayedPrice) new MutationObserver(syncSticky).observe(displayedPrice, { childList: true, subtree: true, characterData: true });
      if ('IntersectionObserver' in window) new IntersectionObserver((entries) => {
        sticky.hidden = entries[0].isIntersecting;
      }, { threshold: 0 }).observe(mainButton);
    }
    update(selected);
  }
  function init(root) {
    qa(root, '[data-rcm-finder]').forEach(initFinder);
    qa(root, '[data-rcm-compatibility]').forEach(initCompatibility);
    qa(root, '[data-section-type="product-template"]').forEach(initProduct);
  }
  document.addEventListener('click', (event) => {
    qa(document, '.rcm-nav details[open]').forEach((details) => { if (!details.contains(event.target)) details.open = false; });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openMenus = qa(document, '.rcm-nav > details[open]');
    const activeMenu = openMenus.find((details) => details.contains(document.activeElement)) || openMenus[0];
    qa(document, '.rcm-nav details[open]').forEach((details) => { details.open = false; });
    if (activeMenu) q(activeMenu, 'summary').focus();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();



